import { FC } from 'react'

import CustomPopup from '../../../UI/Popup'

import './DayCellContent.scss'
import Checkbox from '../../../UI/Inputs/Checkbox'
import { formatDateToCellRefs } from '../../helpers'

const DayCellContent: FC<any> = ({
  cellProps: { dayNumberText, date, isToday, ...other },
  checkedDate,
  setScheduledDate,
  renderScheduleForm,
  ...props
}) => {
  const cellDate = formatDateToCellRefs(date)
  const isChecked = checkedDate === cellDate

  const onDateClick = () => {
    if (cellDate !== checkedDate) {
      setScheduledDate(cellDate)
    }
  }

  return (
    <>
      <CustomPopup
        keepTooltipInside='body'
        position='center center'
        className='schedule-calendar'
        offsetX={9}
        trigger={() => (
          <div className='schedule-calendar__hover-placeholder' onClick={onDateClick} />
        )}
        arrow={false}
        closeOnDocumentClick={false}
        isShowPopup={!isChecked}
        open={isChecked}
      >
        <div
          className={`schedule-calendar__day-hover ${isChecked && 'active'}`}
          onClick={onDateClick}
        >
          <Checkbox type='checkbox' checked={isChecked} onChange={onDateClick} />
          <div className={`schedule-calendar__day-hover__day-number ${isToday && 'today'}`}>
            {dayNumberText}
          </div>
          {isChecked && renderScheduleForm()}
        </div>
      </CustomPopup>

      <div className='day-number'>{dayNumberText}</div>
    </>
  )
}

export default DayCellContent
